import { FC } from "react";
import { useTabSwitcher } from ".";
import classes from "./Tab.module.scss";

interface Props {
  id: string;
}

export const Tab: FC<Props> = ({ id, children }) => {
  const { activeTabID, setActiveTabID } = useTabSwitcher();

  const isActive = id === activeTabID;

  return (
    <div
      className={`${classes.tab} ${isActive && classes.active}`}
      onClick={() => setActiveTabID(id)}
      aria-hidden="true"
    >
      {children}
    </div>
  );
};
